import { getUserId, getVisitorId } from '@ecomm/shared-cookies'

import { handleAtAtTrackingEvent } from '@ecomm/at-at'
import type { TrackingData } from '@ecomm/tracking-types/Data'
import { handleGTMTrackingEvent } from '../gtm'

// Handler for tracking calls for the current event and tracking data
export const handleTrackingEvent =
  (refreshCookieAtom: () => void) => (data: TrackingData) => {
    // Augment data from the event with values that can potentially change after page load
    const augmentedData: TrackingData = {
      ...data,
      userId: getUserId(),
      visitorId: getVisitorId()
    }

    handleGTMTrackingEvent(augmentedData)
    handleAtAtTrackingEvent(augmentedData, refreshCookieAtom)
  }
